export const breakpoints = {
  xs: 0,
  sm: 576,
  md: 768,
  lg: 992,
  xl: 1200,
  xxl: 1600
}

// 生成颜色
export const colors = {
  primaryColor: 'rgba(var(--primary-6))',
  colorRed: '#FF6161',
  colorGreen: '#91F08C',
  colorGreenSoft: '#89d085',
  colorYellow: '#FFC261',
  colorBlue: '#3AADFF',
  colorSkyBlue: '#61D5FF',
  colorOrange: '#FF8D34',
  colorLightPurple: '#CD61FF',
  colorPink: '#FF61AD',
  'text-color': '#000000',
  'text-color-1': '#000000',
  'text-color-2': '#555555',
  'text-color-3': '#999999',
  'text-color-4': '#D9D9D9',
  themeBg: '#F5F6F3'
}
